import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useAuth } from "../auth/AuthContext";
import { useTheme } from "../context/ThemeContext";
import ModalCambiarPassword from "./ModalCambiarPassword";

export default function Topbar({ onToggleSidebar }) {
  const { usuario, cerrarSesion, esAdministrador } = useAuth();
  const { tema, alternarTema } = useTheme();
  const [mostrarCambiarPassword, setMostrarCambiarPassword] = useState(false);

  return (
    <div className="fs-topbar d-flex align-items-center justify-content-between px-3 py-2 sticky-top">
      <button className="btn btn-link text-white d-lg-none p-0 fs-4" onClick={onToggleSidebar} aria-label="Abrir menú">
        <i className="bi bi-list"></i>
      </button>

      <div className="d-none d-lg-flex align-items-center gap-2">
        <span className="badge rounded-pill" style={{ background: "rgba(255,255,255,.15)" }}>
          {esAdministrador ? "Perfil: Administrador" : "Perfil: Cliente"}
        </span>
        {usuario?.nombreFamilia && (
          <span className="badge rounded-pill" style={{ background: "rgba(255,255,255,.15)" }}>
            <i className="bi bi-people-fill me-1"></i>{usuario.nombreFamilia}
          </span>
        )}
      </div>

      <div className="d-flex align-items-center gap-3 ms-auto">
        <button
          className="btn btn-link text-white p-0 fs-5"
          onClick={alternarTema}
          title={tema === "dark" ? "Cambiar a modo claro" : "Cambiar a modo oscuro"}
          aria-label="Cambiar tema"
        >
          <i className={`bi ${tema === "dark" ? "bi-sun-fill" : "bi-moon-stars-fill"}`}></i>
        </button>
        <Dropdown align="end">
          <Dropdown.Toggle
            variant="link"
            className="text-white text-decoration-none p-0"
            style={{ boxShadow: "none" }}
          >
            <i className="bi bi-person-circle fs-5"></i>
            <span className="d-none d-sm-inline small ms-1">{usuario?.nombres}</span>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {usuario?.nombreFamilia && (
              <>
                <Dropdown.ItemText className="d-lg-none small text-muted">
                  <i className="bi bi-people-fill me-1"></i>{usuario.nombreFamilia}
                </Dropdown.ItemText>
                <Dropdown.Divider className="d-lg-none" />
              </>
            )}
            <Dropdown.Item onClick={() => setMostrarCambiarPassword(true)}>
              <i className="bi bi-key me-2"></i>Cambiar contraseña
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
        <button className="btn btn-sm btn-outline-light" onClick={cerrarSesion}>
          <i className="bi bi-box-arrow-right me-1"></i>
          <span className="d-none d-sm-inline">Salir</span>
        </button>
      </div>

      <ModalCambiarPassword show={mostrarCambiarPassword} onHide={() => setMostrarCambiarPassword(false)} />
    </div>
  );
}
